import { fetchMainSiteHeader, transformHeaderNavToMegaNav } from 'cms';
import { isSimpleLink } from 'cms/utils';

import type { MegaNavItem } from 'components/landing-pages-v2/shared/types';

interface IMenuLink {
  name: string;
  href: string;
}

export interface NavHeaderData {
  mainNavLinks: IMenuLink[];
  menuPanelNavLinks: IMenuLink[];
  megaNavData: MegaNavItem[];
  ctaTitle?: string;
  ctaLink?: IMenuLink;
}

export function extractNavData(
  header: Awaited<ReturnType<typeof fetchMainSiteHeader>> | undefined,
): NavHeaderData {
  const mainNavLinks: IMenuLink[] = [];
  header?.fields?.mainNav?.forEach((link) => {
    // mainNav can now be ILpElementLink (simple) or ILpElementSimpleList (with sections)
    // Only extract simple links for mainNavLinks
    if (!isSimpleLink(link)) return;
    if (!link.fields.text || !link.fields.url) return;

    mainNavLinks.push({
      name: link.fields.text,
      href: link.fields.url,
    });
  });

  const menuPanelNavLinks: IMenuLink[] = [];
  header?.fields?.menuPanelNav?.forEach((link) => {
    if (link.fields.text && link.fields.url) {
      menuPanelNavLinks.push({
        name: link.fields.text,
        href: link.fields.url,
      });
    }
  });

  const ctaTitle = header?.fields.menuPanelCtaTitle;
  let ctaLink: IMenuLink | undefined;
  if (header?.fields?.menuPanelCta?.fields.text && header?.fields?.menuPanelCta?.fields.url) {
    ctaLink = {
      name: header.fields.menuPanelCta.fields.text,
      href: header.fields.menuPanelCta.fields.url,
    };
  }

  // Transform header.mainNav (union type) into MegaNavItem[] format
  const megaNavData = transformHeaderNavToMegaNav(header?.fields?.mainNav);

  return { mainNavLinks, menuPanelNavLinks, megaNavData, ctaTitle, ctaLink };
}
